const getters = {
    getManualUploadListData(state) {
      return state.bulkUploadPayoutList;
    },
    };
    
    export default getters;